import { useMemo, useState } from "react";
import { lazify } from "../../lazify";
import { Popover, PopoverButton, PopoverPanel } from "../../popover/popover";
import classes from "../map-nav.module.css";
import { popoverProps } from "../utils";

const panelStyle = { width: "100%", maxWidth: 300 };

export function Guide() {
	const [open, setOpen] = useState(false);

	const Component = useMemo(() => {
		// Don't concatenate the URL. Bundlers won't understand it.
		switch (window.$config.id) {
			case "contenttools":
				return lazify(() => import("./contenttools"));
			case "mapoverrides":
				return lazify(() => import("./mapoverrides"));
			case "mapsure":
				return lazify(() => import("./mapsure"));
			default:
				return lazify(async () => ({ default: () => undefined }));
		}
	}, []);

	return (
		<Popover {...popoverProps} open={open} setOpen={setOpen}>
			<PopoverButton title="Quick Start Guide" className={classes.button}>
				<i className="ico ico-help" />
			</PopoverButton>
			{open && (
				<PopoverPanel style={panelStyle}>
					<div className={classes.heading}>Quick Start Guide</div>
					<div className={classes.guide}>
						<Component />
					</div>
				</PopoverPanel>
			)}
		</Popover>
	);
}
